import { render, staticRenderFns } from "./ManageAcademicActivity.vue?vue&type=template&id=02f9b154"
import script from "./ManageAcademicActivity.vue?vue&type=script&lang=js"
export * from "./ManageAcademicActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports